<template>
  <!-- Visão em Grid -->
  <v-data-table
    v-model="selected"
    :headers="headers"
    :items="items"
    item-key="IdLayoutSql"
    class="elevation-1"
    rows-per-page-text="Registros"
    select-all
    :pagination.sync="pagConfigLayoutSql"
    :loading="loading"
    :search="searchTerm"
    no-data-text="Nenhum registro encontrado"
    @update:pagination="updatePagination"
  >
    <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
    <template v-slot:items="props">
      <tr
        :active="props.selected"
        class="cursor-pointer"
        @dblclick="$emit('editItemSelected', props.item)"
        @click="props.selected = !props.selected"
      >
        <td>
          <v-checkbox :input-value="props.selected" primary color="primary" hide-details></v-checkbox>
        </td>
        <td>{{ props.item.IdLayoutSql }}</td>
        <td>{{ props.item.Descricao }}</td>
        <td>{{ props.item.Titulo }}</td>
        <td>{{ props.item.RecursoSistema }}</td>
        <td>{{ props.item.DescricaoSql }}</td>
        <td>
          <v-avatar size="32" :color="statusLayoutSql(props.item.Status)">
            <span class="white--text">{{ props.item.Status[0] }}</span>
          </v-avatar>
        </td>
      </tr>
    </template>
    <template v-slot:no-results>
      <v-alert
        :value="true"
        color="error"
        icon="warning"
      >Pesquisa por "{{ searchTerm }}" não encontrou resultados.</v-alert>
    </template>
    <template
      v-slot:pageText="props"
    >{{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}</template>
  </v-data-table>
  <!-- Fim Visão em Grid -->
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'GridLayoutSql',
  props: ['searchTerm', 'items', 'loading'],
  data: () => ({
    headers: [
      { text: 'ID', align: 'left', value: 'IdLayoutSql' },
      { text: "Descrição", value: "Descricao" },
      { text: "Título", value: "Titulo" },
      { text: "Recurso Sistema", value: "RecursoSistema" },
      { text: "Sql", value: "DescricaoSql" },
      { text: "Status", value: "Status" }
    ],
    pagConfigLayoutSql: {
      descending: true,
      page: 1,
      rowsPerPage: 10, // -1 for All"
      sortBy: "IdLayoutSql"
    }
  }),
  computed: {
    ...mapGetters(['layoutsSqlSelected']),
    selected: {
      // getter
      get: function () {
        return this.layoutsSqlSelected;
      },
      set: function (value) {
        this.selectLayoutsSql(value);
      }
    }
  },
  methods: {
    ...mapActions(['selectLayoutsSql', 'resetlayoutsSqlSelected']),
    salvaConfigPesquisa() {
      localStorage.setItem("GridLayoutSqlPagConfig", JSON.stringify(this.pagConfigLayoutSql));
    },
    recuperaConfigPesquisa() {
      // Verifica se existe no localStorage o item GridLayoutSqlPagConfig salvo anteriormente
      if (localStorage.getItem('GridLayoutSqlPagConfig')) {
        this.pagConfigLayoutSql = JSON.parse(localStorage.getItem('GridLayoutSqlPagConfig'));
      }
    },
    updatePagination() {
      this.salvaConfigPesquisa();
    },
    statusLayoutSql(status) {
      if (status.includes('A')) return "#263238";
      if (status.includes('C')) return "#bdbdbd";
    },
  },
  created() {
    this.recuperaConfigPesquisa();
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>